var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 35,
    viewBox: "0 0 37 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 35C8.28271 35 0 27.165 0 17.5C0 7.835 8.28271 0 18.5 0C28.7173 0 37 7.835 37 17.5C37 27.165 28.7173 35 18.5 35ZM16.6972 24.2138C17.2219 24.2135 17.7456 24.0233 18.1459 23.6447L28.3275 14.0134C29.1286 13.2556 29.1266 12.0263 28.3239 11.2668C27.5156 10.5022 26.2213 10.5061 25.4204 11.2637L16.6957 19.5168L13.7896 16.7678C12.989 16.0105 11.6846 16.0075 10.8817 16.7668C10.0733 17.5314 10.079 18.7573 10.8814 19.5166L15.2426 23.6418C15.646 24.0234 16.171 24.2134 16.6957 24.2131L16.6972 24.2138Z",
    fill: "url(#paint0_linear_1964_31450)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1964_31450",
    x1: 25.5,
    y1: 31.5,
    x2: 6.5,
    y2: 3.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#334DD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4473EB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckEmail);
export default __webpack_public_path__ + "static/media/check_email.45ef8977fe9ba01648bb73f8f158d2ec.svg";
export { ForwardRef as ReactComponent };